export default {
  props: {
    title: {
      type: String,
      required: false,
    },
    description: {
      type: String,
      required: false,
    },
    items: {
      type: Array,
      required: true,
    },
  },
}
